import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import ReasonCodeDetailsForm from "../../../components/forms/setup/reasonCodes/ReasonCodeDetailsForm";
import { BannerNotificationType } from "../../../components/SimpleNotification";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function ReasonCodesViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [reasonCodes, setReasonCodes] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const getReasonCodes = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `reasonCodes?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setReasonCodes(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createReasonCode = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("reasonCodes/create", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "ReasonCode added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getReasonCodes("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateReasonCode = async function (values, index) {
    let callResult = await makePutApiCall(`reasonCodes/${values.id}`, values);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "ReasonCode updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...reasonCodes.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setReasonCodes({ ...reasonCodes, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddReasonCodeSlideOver = (isEdit, reasonCode, index) => {
    setSlideOver({
      childComponent: (
        <ReasonCodeDetailsForm
          reasonCode={reasonCode}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit
              ? updateReasonCode(payload, index)
              : createReasonCode(payload)
          }
          title={isEdit ? `Update ${reasonCode.name}` : "Add new reasonCode"}
        />
      ),
      open: true,
    });
  };

  const deleteReasonCode = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteReasonCode/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = reasonCodes.data.filter((item) => item.id !== id);
      setReasonCodes({ ...reasonCodes, data: newItems });

      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteReasonCode = function (reasonCode, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteReasonCode(reasonCode.id, index)}
          message={`Are you sure you want to delete  ${reasonCode.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddReasonCodeSlideOver,
    getReasonCodes,
    loading,
    reasonCodes,
    setSlideOver,
    slideOver,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    askDeleteReasonCode,
  };
}
